import classnames from "classnames";

interface PropsType {
    value: number,
    onChange?: (value: number) => void,
    disabled?: boolean,
    step?: number,
    min?: number,
    max?: number,
}

export function InputNumber({value, onChange = () => {}, disabled, step = 1, min = 0, max = 100} : PropsType) {
    const onMinusDiscount = () => {
        if (!disabled && value >= min + step) {
            onChange(value - step);
        }
    };

    const onPlusDiscount = () => {
        if (!disabled && value <= max - step) {
            onChange(value + step);
        }
    };

    return (
        <div className="relative">
            <div className="absolute inset-y-0 start-0">
                <button
                    type="button"
                    onClick={
                        !disabled && value >= min + step ? onMinusDiscount : undefined
                    }
                    className={classnames(
                        "mt-2 ms-2 focus:ring-0 focus:outline-none rounded-full p-2 inline-flex items-center",
                        {
                            "hover:bg-gray-200": !disabled && value >= min + step
                        }
                    )}
                >
                    <svg
                        className="w-3 h-3 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 18 2"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M1 1h16"
                        />
                    </svg>
                </button>
            </div>
            <div className="absolute inset-y-0 end-0">
                <button
                    type="button"
                    onClick={
                        !disabled && value <= max - step ? onPlusDiscount : undefined
                    }
                    className={classnames(
                        "mt-2 me-2 focus:ring-0 focus:outline-none rounded-full p-2 inline-flex items-center",
                        {
                            "hover:bg-gray-200": !disabled && value <= max - step
                        },
                    )}
                >
                    <svg
                        className="w-3 h-3 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 18 18"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 1v16M1 9h16"
                        />
                    </svg>
                </button>
            </div>
            <input
                type="text"
                className={classnames(
                    "text-center bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full px-5 py-2.5",
                    {
                        "bg-gray-200 focus:border-blue-500 focus:ring-blue-500 cursor-not-allowed": disabled,
                        "bg-gray-50 border-gray-300 focus:border-blue-500 focus:ring-blue-500": !disabled,
                    },
                )}
                value={value}
                disabled
                readOnly
            />
        </div>
    );
}